import React from 'react';
import { Flex, Typography } from 'antd';
import styled from 'styled-components';
import { PlusCircleOutlined } from '@ant-design/icons';

import { useTheme } from '../../../../../../hooks/useTheme';

const { Text } = Typography;

export const SuggestionAddButton = ({ onClick }) => {
    const token = useTheme();

    return (
        <StyledWrapper onClick={onClick} vertical={false}>
            <PlusCircleOutlined
                style={{ fontSize: '24px', color: token.colorPrimary }}
            />
            <StyledText $color={token.colorPrimary}>Добавить вопрос</StyledText>
        </StyledWrapper>
    );
};

const StyledWrapper = styled(Flex)`
    cursor: pointer;
    gap: 8px;
    align-items: center;
    max-width: fit-content;
`;

const StyledText = styled(Text)<{ $color: string }>`
    color: ${props => props.$color};
`;
